import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseService } from '../../services/base.service';
import { NotificationService } from '../../services/notifications.service';
import { FUNNEL_STATUS, FUNNEL_TYPE } from '../../enum/constants';
import { activeTranslations } from '../../enum/constants';

@Component({
  selector: 'app-create-funnel',
  templateUrl: './create-funnel.component.html',
  styleUrls: ['./create-funnel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateFunnelComponent {
  // Funnel relative var-s
  public funnelName!: string;
  private readonly funnelType!: FUNNEL_TYPE;
  private readonly funnelStatus: FUNNEL_STATUS = FUNNEL_STATUS.DEFAULT;

  constructor(
    public dialogRef: MatDialogRef<CreateFunnelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly baseService: BaseService,
    private readonly notificationService: NotificationService,
  ) {
    this.funnelName = this.data.data?.funnel;
    this.funnelType = this.data.data.type;
    this.funnelStatus = this.data.data?.status || FUNNEL_STATUS.DEFAULT;
  }

  onSaveClick() {
    if (!(this.funnelName || '').trim()) {
      this.notificationService.showError(
        '',
        activeTranslations.notifications_texts.error.empty_funnel,
      );
    } else {
      this.dialogRef.close({
        name: this.funnelName,
        type: this.funnelType,
        status: this.funnelStatus,
      });
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
